import ApiRequest from "../util/ApiRequest";

export default class Upload {

    uploadImage = async (body) => {
        return await ApiRequest.setMultipart('v1/upload/file',"POST", body);
    }

}
